import React, { Component } from 'react';
import NewsItem from '../components/NewsItem'; 

class News extends Component {
	componentWillMount(){
		window.addEventListener('resize', function(){
            if(window.innerWidth<992){
				let total = document.getElementsByClassName('article-item');
				for(let i=0;i<total.length;i++){
					total[i].removeAttribute('style');
				}
			}
        })
	}
	render(){
		return(
			<div className="container-fluid lg-side-padding article-list style1 margin-top-30">
			{
				this.props.newsData.map( (data,i)=>{
					if(data.visibility==='public')
						return <NewsItem staticData={this.props.staticData} {...data} key={i} />
					else
						return null;
				})
			}
			</div>
		)
	}	
}
export default News;


// WEBPACK FOOTER //
// ./src/components/News.js